/**
 * @file Contains helper functions for compose tabs
 */
import { SearchListType } from './types';

/**
 * Mapping between section type and heading title
 */
const mapping: Record<SearchListType, string | null> = {
  groups: 'ASSIGNMENT__GROUPS__HEADING',
  labels: null,
  members: 'SETTINGS__PEOPLE',
};

/**
 * Get translation key for the heading of the section group
 *
 * @param searchType Type of the search group (members, groups or labels)
 * @returns          Translation key or null if no heading
 */
export const getHeadingTranslationKey = (
  searchType: SearchListType,
): string | null => {
  return mapping[searchType];
};
